import { Controller } from "@hotwired/stimulus"

// Gère l'expansion/repli du panel de filtres sur les pages index.
// L'état persiste dans sessionStorage par page.
export default class extends Controller {
  static values = { storageKey: String }

  connect() {
    const key = this.storageKeyValue || `filters-panel:${window.location.pathname}`
    const expanded = sessionStorage.getItem(key) === "1"
    this.element.dataset.filtersExpanded = expanded ? "true" : "false"
  }

  toggle(event) {
    event.preventDefault()
    const current = this.element.dataset.filtersExpanded === "true"
    const next = !current
    this.element.dataset.filtersExpanded = next ? "true" : "false"
    const key = this.storageKeyValue || `filters-panel:${window.location.pathname}`
    sessionStorage.setItem(key, next ? "1" : "0")
  }
}
